module.exports = __webpack_public_path__ + "static/media/RP-87.71ff6ff0.pdf";